import { Box, Typography } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';


import { type PatientFormValues } from '../../components/Forms/formTypes.js';
import PatientInformationForm from '../../components/Patients/PatientInformationForm.js';
import useSnackBar from '../../hooks/use-snack-bar.js';
import { track, Events, useMutation } from '../../utils/index.js';

const PatientNew = () => {
  const navigate = useNavigate();
  const snackBar = useSnackBar();
  const mutation = useMutation({
    path: '/patients',
    method: 'POST',
    onSuccess(response) {
      const {
        data: { id: patientId },
      } = response;
      snackBar.success('New patient created successfully!');

      track(Events.PatientCreation, {
        patientId,
      });

      navigate(`/patients/${patientId}/update`);
    },
  });

  async function onSubmit(values: PatientFormValues, callback: () => void) {
    const { timeZone } = values;
    mutation.mutate(
      {
        ...values,
        timeZone: timeZone?.name,
      },
      {
        onSuccess: callback,
      },
    );
  }

  return (
    <Box sx={{ maxWidth: 560 }}>
      <Typography variant={'h2'} component={'h1'} sx={{ mb: 2 }}>
        New patient
      </Typography>
      <PatientInformationForm onSubmit={onSubmit} />
    </Box>
  );
};

export default PatientNew;
